var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('HeroHeader'),_c('Partners'),_c('Introduction'),_c('TimerangeSeparator'),_c('WorldMap'),_c('CountrySeparator'),_c('DataVisualization'),_c('Footer',{staticStyle:{"margin-top":"40px"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }